import { PartnerEncumbrancesContextType } from '../types/PartnerEncumbrancesContextType';

export const partnerEncumbrancesInitValue: PartnerEncumbrancesContextType = {
  data: {
    encumbrances: [],
    expandedRows: new Set(),
    totalEncumbrances: 0,
    page: 1,
    rowsPerPage: 10,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleToggleRowExpansion: () => {},
    handleViewEncumbrance: () => {},
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
  },
};
